export default {
	getFieldInfo: (state) => (field) => {
		return state.formData[field];
	},
	getParkingLocations: state => {
		return state.parkingLocations;
	},
	getStepInfo: state => (step) => {
		return state.steps[step];
	},
	getStepComplete: state => (step) => {
		return state.steps[step];
	},
	getStep: state => state.step,
	isAuthenticated: state => !!state.token,
	authStatus: state => state.status,
	getToken: state => state.token,
	getUser: state => state.user,
	getProductionCompanies: state => state.productionCompanies,
	isLoggedIn: state => state.userLoggedIn,
	formDataWasRecovered: state => state.recoveredFormData,
	formSavedDataWasRecovered: state => state.recoveredSavedFormData,
	getProdCompanyLoadStatus: state => state.productionCompanies.length == 0,
	getRoadList: state => state.roadList,
	getIntersectionList: state => state.intersectionList,
	getAddressNameList: state => state.addressNameList,
	Address1List: state => state.Address1List,
	Address2List: state => state.Address2List,
	getFacilityList: state => state.facilityList,
	getParkList: state => state.parkList,
	getFormData: state => state.formData,
	submissionDetails: state => state.submissionDetails,
	isLoading: state => state.loading,
	formType: state => state.formType,
	facilityId: state => (item) => state.assetIdList[item],
	newProductionCompany: state => state.newProductionCompany,
	loadingMsg: state => state.loadingMsg,
	//saveFormDataDetails:state=>state.saveFormDataDetails,
	savedStatusDisplayDetails:state=>state.savedStatusDisplayDetails,
	formSaveDataList:state=>state.formSaveDataList,
	deleteFormDataDetails:state=>state.deleteFormDataDetails,
	//getFormSavedData: state => state.formSavedData,
	formSavedData: state => state.formSavedData,
	savedAppId: state => state.savedAppId,
	applicationName: state => state.formSavedData.ApplicationName,
	savedAppValidationList: state => state.savedAppValidationList
}